import CustomTable from '@myComponents/CustomTable';
import { LIST_EMOTIONS_RANK } from '../../../graphql/Query/ranking';
import { useQuery } from '@apollo/client';
import { columns } from './Columns';
import * as XLSX from 'xlsx';

const RankEmotionList = () => {
  const { data, refetch, loading } = useQuery(LIST_EMOTIONS_RANK);

  function convertArrayOfObjectsToXLSX(array) {
    const translate = [
      {
        key: 'ranking',
        name: ['Ranking']
      },
      {
        key: 'name',
        name: ['Nombre']
      },
      {
        key: 'episodes',
        name: ['Episodios'],
        episodeFormat: true
      },
      {
        key: 'likes',
        name: ['Me gusta']
      },
      {
        key: 'started',
        name: ['Empezado']
      },
      {
        key: 'finished',
        name: ['Completado']
      }
    ];

    const keys = [
      'ranking',
      'cover',
      'name',
      'episodes',
      'likes',
      'started',
      'finished',
      'membership',
      'status'
    ];

    const _data = new Map();

    translate.forEach(({ key, ...rest }) => _data.set(key, rest));

    const result = [];

    let firstRow = [];
    [..._data.values()].forEach(
      (item) => (firstRow = [...firstRow, ...item.name])
    );
    result.push(firstRow);

    array.forEach((item, idx) => {
      let temp = [idx + 1];
      keys.forEach((key) => {
        const _item = _data.get(key);
        if (_item) {
          if (_item.episodeFormat) {
            temp = [...temp, item[key].length];
          } else {
            const exists = item[key];
            if (exists || exists === 0) {
              if (_item.statusFormat) {
                temp = [...temp, item[key] ? 'Activo' : 'Inactivo'];
              } else {
                temp = [...temp, item[key]];
              }
            }
          }
        }
      });
      result.push(temp);
    });

    return result;
  }

  function downloadCSV(array) {
    const anchor = document.createElement('a');
    const data = convertArrayOfObjectsToXLSX(array);
    if (data === null) return;

    const filename = 'subliful_all_ranking_emociones.xlsx';

    const workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(data);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    const xlsbin = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'binary'
    });

    const buffer = new ArrayBuffer(xlsbin.length),
      array2 = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array2[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    const xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(xlsblob);

    anchor.href = url;
    anchor.download = filename;
    anchor.click();
  }

  return (
    <CustomTable
      loading={loading}
      store={data?.listEmotionsRank?.docs || []}
      data={{ ...data?.listEmotionsRank, docs: undefined }}
      refetch={refetch}
      headerOptions={{
        notShowRowList: true,
        type: 'add',
        name: 'Descargar',
        handle: () => {
          if (data.listEmotionsRank.docs.length) {
            downloadCSV(data.listEmotionsRank.docs);
          }
        }
      }}
      pagination={false}
      variables={{ search: {} }}
      columns={columns}
    />
  );
};

export default RankEmotionList;
